import React from 'react'

import { AudioTrack } from '../AudioTrack/AudioTrack'
import { useHeadlessParticipant } from '../../../webrtc/webRTCRoom'

const VideoPlaybackAudioTrack = () => {
  const headless = useHeadlessParticipant()

  if (!headless?.tracks.screenAudio) return null

  return <AudioTrack track={headless.tracks.screenAudio} />
}

export { VideoPlaybackAudioTrack }
